// More specific than /@lang/product/@slug/@variantSlug — Vike prefers
// literal segments over parameters, so "offerte" wins over @variantSlug.
export default '/@lang/product/@slug/offerte'
